import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHead } from "../components/ui-bits";
import { Phone, EnvelopeSimple, VideoCamera, UsersThree } from "@phosphor-icons/react";

export default function Team() {
  const [team, setTeam] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAgent = user?.role === "agent";
  useEffect(() => { api.get("/team").then((r) => setTeam(r.data)); }, []);

  return (
    <div>
      <PageHead eyebrow={isAgent ? "Virtualeena Team" : "Your Assigned Professionals"} title="Team Directory" />
      {team.length === 0 && (
        <div className="card p-8 text-center" data-testid="team-empty">
          <UsersThree size={32} className="mx-auto mb-2 text-[#bbb]" />
          <p className="text-sm text-[#888]">No team members allocated yet.</p>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {team.map((m, i) => (
          <div key={m.id || i} data-testid={`team-${i}`} className="card p-6">
            <div className="flex items-center gap-4 mb-4">
              {m.avatar ? <img src={m.avatar} alt={m.name} className="w-14 h-14 rounded-sm object-cover grayscale" />
                : <div className="w-14 h-14 rounded-sm bg-[#002FA7] text-white flex items-center justify-center font-head font-black text-xl">{m.name?.[0]}</div>}
              <div>
                <h3 className="font-head font-bold">{m.name}</h3>
                <p className="label" style={{ color: "#002FA7" }}>{m.role}</p>
              </div>
            </div>
            <div className="space-y-1.5 text-sm text-[#555] mb-4">
              {m.email && <p className="flex items-center gap-2"><EnvelopeSimple size={15} /> {m.email}</p>}
              {m.phone && <p className="flex items-center gap-2"><Phone size={15} /> {m.phone}</p>}
              {(m.services || []).length > 0 && <p className="text-xs text-[#888]">{m.services.join(" · ")}</p>}
            </div>
            <button data-testid={`meet-${i}`} onClick={() => navigate(isAgent ? "/agent/meetings" : "/meetings")}
              className="w-full flex items-center justify-center gap-2 text-sm border border-black/20 hover:bg-black/5 rounded-sm py-2 transition-colors">
              <VideoCamera size={16} /> Schedule Meeting
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
